export const mockBooks = [
  {
    id: '1',
    title: 'The Hobbit',
    author: 'J.R.R. Tolkien',
    genre: 'Fantasy',
    cover: 'https://covers.openlibrary.org/b/id/6979861-M.jpg',
    status: 'read', // tbr, reading, read, dnf
    rating: 5,
    totalPages: 310,
    dateFinished: '2024-01-15',
    trophyStyle: 'gold-leaf',
    spineColor: '#2e5a44'
  },
  {
    id: '2',
    title: 'Project Hail Mary',
    author: 'Andy Weir',
    genre: 'Sci-Fi',
    cover: 'https://covers.openlibrary.org/b/id/10593633-M.jpg',
    status: 'reading',
    rating: 0,
    totalPages: 496,
    currentPage: 150,
    trophyStyle: 'paperback',
    spineColor: '#3d6c7d'
  },
  {
    id: '3',
    title: 'Mistborn: The Final Empire',
    author: 'Brandon Sanderson',
    genre: 'Fantasy',
    cover: 'https://covers.openlibrary.org/b/id/8891842-M.jpg',
    status: 'tbr',
    rating: 0,
    totalPages: 541,
    affiliateLinks: {
      bookshop: 'https://bookshop.org/a/99999/9780765350381',
      amazon: 'https://amzn.to/example-mistborn'
    }
  },
  {
    id: '4',
    title: 'Atomic Habits',
    author: 'James Clear',
    genre: 'Non-Fiction',
    cover: 'https://covers.openlibrary.org/b/id/10633785-M.jpg',
    status: 'read',
    rating: 4,
    totalPages: 320,
    dateFinished: '2024-02-10',
    trophyStyle: 'leather',
    spineColor: '#4f3e2e'
  }
];
